export var warning = function warning(message) {
  if (console && console.warn) {
    console.warn(message);
  }
};